class StickySubnav extends HTMLElement {
  constructor() {
    super();

    this.totalHeight = this.offsetHeight;
    this.distance;

    this.links = this.querySelectorAll('.sticky-subnav__item--anchor');
    this.sections = [];

    this.init();
  }

  init() {
    document.documentElement.style.setProperty("--subnav-height", this.totalHeight + "px");
    this.classList.add("__initiated");

    // Gather corresponding sections for each link
    this.links.forEach((link) => {
      let correspondingSection = document.querySelector(link.getAttribute('href'));
      if (correspondingSection) {
        this.sections.push(correspondingSection);
      }

      // Add click event listener to each link
      link.addEventListener('click', (event) => {
        // Ensure the active link is updated immediately after the page scrolls
        this.checkActiveSection();
      });
    });

    // Attach scroll listener to the window or document
    window.addEventListener(
      "scroll",
      () => {
        // Handle sticky positioning of subnav
        let current = this.getBoundingClientRect().top;
        if (current == this.distance) {
          if (!this.classList.contains("__stuck")) {
            this.classList.add("__stuck");
          }
        } else if (this.classList.contains("__stuck")) {
          this.classList.remove("__stuck");
        }
        this.distance = this.getBoundingClientRect().top;

        // Call function to check active section
        this.checkActiveSection();
      },
      true
    );
  }

  checkActiveSection() {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    // Loop through sections and check if their center has passed a certain scroll position
    this.sections.forEach((section, index) => {
      const sectionTop = section.offsetTop; 
      const sectionHeight = section.offsetHeight; 
      const sectionMiddle = sectionTop + sectionHeight / 2; 

      // Compare the section's middle with the current scroll position
      if (sectionMiddle <= scrollTop + (window.innerHeight / 2) ) {
        this.links.forEach(link => link.classList.remove('__active')); 
        this.links[index].classList.add('__active');
      }
    });
  }
}

customElements.define("sticky-subnav", StickySubnav);
